"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeIndex = void 0;

/**
 * Remaps the progress into the active index, given an array of `length`.
 * @param progress number from 1 to 100
 * @param length length of an array
 */
var activeIndex = function activeIndex(_ref) {
  var progress = _ref.progress,
      length = _ref.length;
  return Math.round(progress * (length - 1) / 100);
};

exports.activeIndex = activeIndex;
//# sourceMappingURL=activeIndex.js.map